"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListDirection = void 0;
exports.ListDirection = {
    FORWARD: 'forward',
    BACKWARD: 'backward'
};
//# sourceMappingURL=list-direction.js.map